<template>
  <cTable ref="form" :methods="methods" :form="form" :config="config"> 
	</cTable>
</template>

<script>
// import { getCountry } from "@/api/system/country";
import {
	inboundSave,
} from "@/api/tracker/warehousingNumber";
import cTable from "@/base/common/index";
import format from "@/utils/format.js";
import Goods from './goods'
export default {
  name: "warehousing",
  components: {
		Goods,
    cTable,
  },
  async created() {
    
  },
  methods: {
    // 注入下拉框的值
    setDataFn(nowVal) {
      this.form.fields.forEach((el, idx) => {
        if (el.key.split("-")[1] && nowVal[el.key.split("-")[1]]) {
          this.$set(
            this.form.fields[idx],
            "options",
            nowVal[el.key.split("-")[1]]
          );
        }
      });
    },
		computedVolumn(row){
			row.volume = parseFloat((row.height * row.width * row.length * row.quantity / 1000000).toFixed(2)) || 0
		}
  },
  data() {
    let that = this;
    return {
			goods:[],
      selData: {},
      methods: {
				inboundSave
      },
      config: {
        bind: { style: "min-height:100%;height:auto" },
      },
      form: {
        config: {
          formBind: {
						style: 'width:90%;margin:0 auto',
            labelWidth: 140,
          },
          rowBind: {
            gutter: 13,
            style: {
              marginBottom: "20px",
            },
          },
          rules: {
            quantity: [
              {
                required: true,
                message: "cannot be empty",
                trigger: "blur",
            		type:'number',
            		min:1,
            		max:9999
              },
            ],
            weight: [
              {
                required: true,
                message: "cannot be empty",
                trigger: "blur",
            		type:'number',
            		min:1,
            		max:99999
              },
            ],
            width: [
              {
                required: true,
                message: "cannot be empty",
                trigger: "blur",
            		type:'number',
            		min:1,
            		max:999
              },
            ],
						length: [
						  {
						    required: true,
						    message: "cannot be empty",
						    trigger: "blur",
								type:'number',
								min:1,
								max:999
						  },
						],
						warehouse_number: [
						  {
						    required: true,
						    message: "cannot be empty",
						    trigger: "blur",
						  },
						],
						height: [
						  {
						    required: true,
						    message: "cannot be empty",
						    trigger: "blur",
								type:'number',
								min:1,
								max:999
						  },
						],
          },
        },
        grid: [
					{warehouse_number:24},
					{quantity:24},
					{weight:24},
					// {length:8,width:8,height:8},
					{volume:24},
					// {create_time:24},
					{remarks:24},
					{goods:24},
          {
            button: 10,
          },
        ],
        fields: [
					{
					  key: "goods",
					  name: ()=> this.$t('des_goods') + this.$t('information'),
						render:(h,p)=>{
							if(!this.goods.length)this.goods.push({
								name:'',
								sku:'',
								length:0,
								height:0,
								width:0,
								quantity:0,
								volume:0,
								weight:0,
							})
							return h(Goods,{attrs:{
								row:p.row,
								list:this.goods
							}})
						}
					},
					{
					  name: this.$t("warehousingNumber"),
						component: "Input",
						bind:{
							style:'width:100%'
						},
						placeholder:()=>this.$t("enter")+this.$t("warehousingNumber"),
					  key: "warehouse_number",
					},
          {
            name: this.$t("noofpieces"),
          	component: "InputNumber",
						disabled:true,
          	bind:{
          		style:'width:100%'
          	},
          	default:0,
          	placeholder:()=>this.$t("enter")+this.$t("noofpieces"),
            key: "quantity",
						methods:{
							'on-change':({formData})=>{
								this.computedVolumn(formData)
							}
						}
          },
          {
            name: this.$t("Weight"),
            key: "weight",
          	component: "InputNumber",
						disabled:true,
          	bind:{
          		style:'width:100%'
          	},
          	default:0,
            placeholder:()=>this.$t("enter")+this.$t("Weight"),
						methods:{
							'on-change':({formData})=>{
								this.computedVolumn(formData)
							}
						}
          },
					{
					  name: this.$t("length"),
					  key: "length",
						component: "InputNumber",
						bind:{
							style:'width:100%'
						},
						default:0,
					  placeholder:()=>this.$t("enter")+this.$t("length"),
						methods:{
							'on-change':({formData})=>{
								this.computedVolumn(formData)
							}
						}
					},
					{
					  name: this.$t("skuWidth"),
					  key: "width",
						component: "InputNumber",
						bind:{
							style:'width:100%'
						},
						default:0,
					  placeholder:()=>this.$t("enter")+this.$t("skuWidth"),
						methods:{
							'on-change':({formData})=>{
								this.computedVolumn(formData)
							}
						}
					},
					{
					  name: this.$t("height"),
					  key: "height",
						component: "InputNumber",
						bind:{
							style:'width:100%'
						},
						default:0,
					  placeholder:()=>this.$t("enter")+this.$t("height"),
						methods:{
							'on-change':({formData})=>{
								this.computedVolumn(formData)
							}
						}
					},
          {
            name: this.$t("skuVolume"),
            key: "volume",
          	component: "InputNumber",
          	bind:{
          		style:'width:100%'
          	},
          	default:0,
						disabled:true,
            placeholder:()=>this.$t("enter")+this.$t("skuVolume"),
          },
          {
            key: "create_time",
          	name: this.$t("inboundTime"),
            component: "DatePicker",
            placeholder: () => this.$t("select") + this.$t("inboundTime"),
            bind: {
              clearable: false,
              type: "datetime",
              style: {
                width: "100%"
              }
            },
            disabledDate: true
          },
          {
            name: this.$t("Remarks"),
            key: "remarks",
          	component: "Input",
          	bind: {
          	  type: "textarea",
          	},
            placeholder:()=>this.$t("enter")+this.$t("Remarks"),
          },
        ],
        buttons: [
          {
            name: () => this.$t("order_submit"),
            bind: { type: "primary" },
            isSub: true,
            methods: {
              click:({ grid, buttons, formData, result })=> {
								let table = this.$refs['form']
                table
                  .handleRequestMethods("inboundSave", Object.assign({},result,{goods:this.goods}), true)
                  .then((res) => {
										Array(this.goods.length).fill(1).forEach(t=>this.goods.pop())
										table.$refs["form"].$refs['form'].resetFields();
										this.$forceUpdate()
                  });
                // console.log("formData", grid, formData);
              },
            },
          },
        ],
      },
    };
  },
};
</script>
<style type="text/css">
/* @page{
    size: 7cm 8cm;
  } */
</style>
<style lang="scss" scoped></style>
